import * as React from "react";
import {connect} from "react-redux";
import SidebarComponent from "../components/SidebarComponent";
import {conversationsSelector} from "../../_data/selectors";
import {currentUserSelector} from "../../user/selectors";

const mapStateToProps = (state) => {
    return {
        currentUser: currentUserSelector(state),
        unreadMessageCount: conversationsSelector(state).filter(c => c.unreadCount > 0).count()
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

const SidebarContainer = connect(mapStateToProps, mapDispatchToProps)(SidebarComponent);
export default SidebarContainer;


// WEBPACK FOOTER //
// ./app/client/dashboard/containers/SidebarContainer.tsx